import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReturnReason } from "src/models/Maintenance/ReturnReason";

interface ReturnReasonState {
  returnReasons: IReturnReason[];
  returnReasonToEdit: IReturnReason | null;
}

const initialState: ReturnReasonState = {
  returnReasons: [],
  returnReasonToEdit: null,
};

const returnReasonSlice = createSlice({
  name: "ReturnReason",
  initialState,
  reducers: {
    setReturnReasonList: (state, action: PayloadAction<IReturnReason[]>) => {
      state.returnReasons = action.payload;
    },
    concatListReturnReason: (
      state: ReturnReasonState,
      action: PayloadAction<IReturnReason[]>
    ) => {
      state.returnReasons = [...state.returnReasons.concat(action.payload)];
    },
    setReturnReasonToEdit: (
      state,
      action: PayloadAction<IReturnReason | null>
    ) => {
      state.returnReasonToEdit = action.payload;
    },
    addReturnReason: (state, action: PayloadAction<IReturnReason>) => {
      state.returnReasons.push(action.payload);
    },
    updateReturnReason: (state, action: PayloadAction<IReturnReason>) => {
      let itemIndex = state.returnReasons.findIndex(
        item => item.returnReasonId === action.payload.returnReasonId
      );
      if (itemIndex !== -1) state.returnReasons[itemIndex] = action.payload;
    },
    deleteReturnReason: (state, action: PayloadAction<number>) => {
      const newArray = state.returnReasons.filter(
        item => item.returnReasonId !== action.payload
      );
      state.returnReasons = newArray;
    },
  },
});

export const {
  setReturnReasonList,
  concatListReturnReason,
  setReturnReasonToEdit,
  addReturnReason,
  updateReturnReason,
  deleteReturnReason,
} = returnReasonSlice.actions;

export default returnReasonSlice.reducer;
